exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\naudio[data-v-62db2410] {\n  background-color: #f2f4f4 !important;\n  width: 450px;\n  border-radius: 3px;\n}\n.lang-prof-desc p[data-v-62db2410] {\n  color: #455666;\n  font-weight: normal;\n  font-size: .9rem;\n  line-height: 1.5;\n}\n", ""]);

// exports
